import { cn } from "@izicvs/utils";
import { motion } from "framer-motion";

// Define constants for CSS values to avoid ESLint warnings
const BG_POSITION = "left center";
const BG_REPEAT = "no-repeat";
const DISPLAY_INLINE = "inline";

export const Highlight = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <motion.span
      initial={{
        backgroundSize: "0% 100%",
      }}
      animate={{
        backgroundSize: "100% 100%",
      }}
      transition={{
        duration: 2,
        ease: "linear",
        delay: 0.5,
      }}
      style={{
        backgroundRepeat: BG_REPEAT,
        backgroundPosition: BG_POSITION,
        display: DISPLAY_INLINE,
      }}
      className={cn(
        `relative inline-block rounded-lg bg-gradient-to-r from-indigo-300 to-purple-300 px-1 pb-1 dark:from-indigo-500 dark:to-purple-500`,
        className,
      )}
    >
      {children}
    </motion.span>
  );
};
